import { Component, EventEmitter, Input, Output, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { AdminService, BaseComponent, UserService, WorkspaceService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

/** Beta string_id -> Jira project key mapping for default project selection */
export const BETA_TO_JIRA_PROJECT: Record<string, string> = {
  notion: "NS",
  notion6: "NS",
};

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-create-jira-ticket",
  templateUrl: "create-jira-ticket.component.html",
  standalone: false,
})
export class CreateJiraTicketComponent extends BaseComponent implements OnInit {
  @Input() data: any = {};
  @Input() attachments: any = [];
  @Input() linkToPost: string;
  @Output() completed: EventEmitter<any> = new EventEmitter();
  public loading: boolean = false;
  protected jiraProjects: string[] = ["SO", "PRS", "AS", "VN", "AF", "EF", "CF", "BB", "NS", "ESBT", "ATM", "UT", "IRM", "QX", "DENG"].sort((a, b) => a.localeCompare(b));

  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal,
    public adminService: AdminService,
    public workspaceService: WorkspaceService
  ) {
    super(userService);
  }

  ngOnInit() {
    if (!this.data.priority) this.data.priority = "Medium (P3)";
    if (!this.data.type) this.data.type = "Task";
    this.data.summary = this.data.summary.replace(/&nbsp;/g, " ");
    if (this.data.project) this.ensureValidType();
  }

  /** Issue types available for the given project, mirroring the template options. */
  validTypesForProject(project: string): string[] {
    const types: string[] = [];
    if (["PRS", "SO", "NS", "DENG"].includes(project)) types.push("Story", "Task");
    types.push("Bug");
    if (!["PRS", "DENG"].includes(project)) types.push("Improvement", "New Feature");
    return types;
  }

  /** Keep the selected type valid when the project changes, defaulting to the first option. */
  ensureValidType() {
    const validTypes = this.validTypesForProject(this.data.project);
    if (!validTypes.includes(this.data.type)) {
      this.data.type = validTypes[0];
    }
  }

  submit() {
    if (this.data.summary && this.data.description) {
      this.loading = true;
      if (this.attachments?.length) {
        this.data.description += "\n\nAttachments:\n";
        this.attachments.forEach((attachment) => {
          this.data.description += `![File](${attachment.url})\n`;
        });
      }
      this.data.description += `\n\n[Link to Post](${this.linkToPost})`;
      this.adminService.createJiraTicket(this.data).subscribe((res: any) => {
        this.loading = false;
        this.completed.next(res);
        this.activeModal.close();
      });
    } else {
      alert("You must fill out a version number (ex: 1.0.0) and at least one download URL (Mac, Windows, or Windows 64-bit)");
    }
  }
}
